import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { HSAnalyticsContext } from '../context/HSAnalyticsContext';
export default function HSAnalyticsProvider({
  children
}) {
  const [initialPageLoad, setInitialPageLoad] = useState(true);
  return /*#__PURE__*/_jsx(HSAnalyticsContext.Provider, {
    value: {
      initialPageLoad,
      setInitialPageLoad
    },
    children: children
  });
}